import { lazy, Suspense } from 'react'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { PublicProvider } from '../components/public/PublicProvider'
import { localeFromPathname } from '../lib/public-seo'
import PublicLandingRoute from './PublicLandingRoute'

const AuthenticatedAppBundle = lazy(() => import('./AuthenticatedAppBundle'))

function isLandingPath(pathname: string) {
  const parts = pathname.split('/').filter(Boolean)
  return parts.length === 0 || (parts.length === 1 && Boolean(localeFromPathname(pathname)))
}

function AppBundleRoutes() {
  const { pathname } = useLocation()
  if (isLandingPath(pathname)) {
    const locale = localeFromPathname(pathname) || 'en'
    return (
      <PublicProvider key={locale} locale={locale}>
        <PublicLandingRoute />
      </PublicProvider>
    )
  }

  return (
    <Suspense fallback={null}>
      <AuthenticatedAppBundle />
    </Suspense>
  )
}

export default function AppBundle() {
  return (
    <BrowserRouter>
      <AppBundleRoutes />
    </BrowserRouter>
  )
}
